import type { NotificationData } from '../../services/notification.service';
import { resolveLprEntryIdFromNotificationData } from '../../notifications/notification.utils';

/** Match NotificationService SSE plate resolution for trace correlation. */
export function resolveLprTraceLicensePlate(data: any): string {
  if (!data || typeof data !== 'object') {
    return '';
  }
  const record = data as Record<string, any>;
  const notification =
    record && typeof record['type'] === 'string' && 'data' in record && record['timestamp'] != null
      ? (record as any as NotificationData)
      : null;
  const row = (notification?.data ?? record) as Record<string, any>;
  const nested =
    row['data'] && typeof row['data'] === 'object' && !Array.isArray(row['data'])
      ? (row['data'] as Record<string, any>)
      : null;
  const raw =
    row['plate'] ??
    row['vehicle_license_plate'] ??
    row['vehicleLicensePlate'] ??
    row['license_plate'] ??
    row['licensePlate'] ??
    nested?.['plate'] ??
    nested?.['vehicle_license_plate'] ??
    nested?.['vehicleLicensePlate'] ??
    nested?.['license_plate'] ??
    nested?.['licensePlate'] ??
    '';
  return typeof raw === 'string' ? raw.trim().toUpperCase() : '';
}

/** Shared correlation fields for LPR / Way notification tracing (SSE → modal). */
export function resolveLprNotificationTraceContext(
  source: NotificationData | Record<string, any> | null | undefined,
  overrides: Record<string, any> = {}
): Record<string, any> {
  const notification =
    source && typeof source === 'object' && 'type' in source && 'data' in source
      ? (source as NotificationData)
      : null;
  const row = (notification?.data ?? source ?? {}) as Record<string, any>;
  const plate = resolveLprTraceLicensePlate(notification ?? row);

  return {
    notificationType: notification?.type ?? row['event'] ?? null,
    licensePlate: plate || undefined,
    lane_id: row['lane_id'] ?? null,
    roi_id: row['roiID'] ?? row['camera_roi'] ?? row['roiId'] ?? null,
    lpr_entry_id: resolveLprEntryIdFromNotificationData(row) || null,
    auto_redeem: row['auto_redeem'] === true || row['gate_opened'] === true,
    location_id: row['location_id'] ?? row['locationId'] ?? null,
    ...overrides,
  };
}
